import React from "react";
import Modal from "react-native-modal";
import ResponsiveContent from "../shared/responsive-content";
import { View, Pressable, Text } from "react-native";
import CloseIcon from "@/assets/svgs/close-icon";
import { Button } from "../ui/button";

function ReviewLessonReportModal({
  isVisible,
  onClose,
  onDismiss,
  onAccept,
}: {
  isVisible: boolean;
  onClose: () => void;
  onDismiss: () => void;
  onAccept: () => void;
}) {
  return (
    <Modal
      animationIn="slideInUp"
      animationOut="slideOutDown"
      isVisible={isVisible}
      onBackdropPress={onClose}
      useNativeDriver
      useNativeDriverForBackdrop
      hideModalContentWhileAnimating
    >
      <ResponsiveContent>
        <View className="mx-4 bg-teachLoop-creamBase rounded-xl px-8 py-10">
          <View className="items-end">
            <Pressable
              onPress={onDismiss}
              className="active:opacity-80"
              style={{ marginHorizontal: -12 }}
            >
              <CloseIcon
                pathClassName="stroke-teachLoop-textPrimary"
                className="size-6"
              />
            </Pressable>
          </View>
          <View className="gap-8">
            <Text className="font-zilla-slab-medium font-medium text-[28px] leading-[1.2] text-black">
              Your report is ready
            </Text>
            <Text className="text-base font-geologica-regular font-normal leading-[1.5] text-teachLoop-textPrimary">
              Please review and confirm the report to process your payment. You
              can find your report in the &apos;completed lessons&apos; list on
              the &apos;lesson schedule&apos; tab
            </Text>
            <Button
              fullWidth
              size="sm"
              intent="primary"
              outline
              onPress={onAccept}
              className="border"
            >
              <Button.Text size="sm" intent="primary">
                Review and submit report
              </Button.Text>
            </Button>
          </View>
          <View className="h-3" />
        </View>
      </ResponsiveContent>
    </Modal>
  );
}

export default ReviewLessonReportModal;
